import { type Meta } from '../types/docs';
import { UPLOAD_ANALYTICS_COMMON_META_PARAMS } from './uploadAnalyticsMetaParams';

const META: Meta = {
  description: 'Upload completed successfully',
  name: 'upload_completed',
  params: [
    ...UPLOAD_ANALYTICS_COMMON_META_PARAMS,
    {
      description: 'Time from queue creation to completion in milliseconds',
      name: 'upload_duration_ms',
      required: false,
      type: 'number',
    },
    {
      description: 'Which presigned URL type the upload used; multipart uploads may be mixed',
      name: 'upload_url_type',
      required: false,
      type: 'enum',
      values: ['primary', 'fallback', 'mixed'],
    },
  ],
};

export default META;
